import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "site-body pt-15%" }
const _hoisted_2 = { class: "content-wrap relative py-0 w-auto my-0 mx-auto px-4 lg:px-0 lg:w-950px font-normal" }
const _hoisted_3 = { class: "homepage-welcome mb-8 mt-18% text-left text-xl" }
const _hoisted_4 = {
  key: 0,
  class: "welcome mb-0 mt-18% text-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-1.5em font-bold leading-none w-full m-0 p-0 mb-8 box-border text-white font-comfortaa" }, " animeboxd ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "text-1em font-semibold m-0 p-0 box-border text-white" }, " Connect with MyAnimeList. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "text-1em font-semibold m-0 p-0 box-border text-white" }, " Track anime you've watched. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "text-1em font-semibold m-0 p-0 box-border text-white" }, "The modern way.", -1)
const _hoisted_9 = {
  key: 1,
  class: "welcome mb-0 mt-18% text-center"
}
const _hoisted_10 = { class: "text-2xl leading-none w-full m-0 p-0 mb-8 box-border text-white font-comfortaa" }
const _hoisted_11 = {
  key: 2,
  class: "anime-list relative pb-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", { class: "section-heading tracking-wider border-b border-gray-highlights mb-2.5 pb-1.5 uppercase text-base hover:underline" }, " Suggested Anime... ", -1)
const _hoisted_13 = { class: "anime-list overflow-hidden h-full -ml-2% flex flex-wrap relative z-0 list-none justify-center" }
const _hoisted_14 = { class: "anime-list relative pb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", { class: "section-heading tracking-wider border-b border-gray-highlights mb-2.5 pb-1.5 uppercase text-base hover:underline" }, " Most Popular Anime... ", -1)
const _hoisted_16 = { class: "anime-list overflow-hidden h-full -ml-2% flex flex-wrap relative z-0 list-none justify-center" }
const _hoisted_17 = { class: "shows pb-8 relative" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "section-heading tracking-wider border-b border-gray-highlights mb-2.5 pb-1.5 uppercase text-base hover:underline" }, " Top Airing Anime... ", -1)
const _hoisted_19 = { class: "anime-list overflow-hidden h-full -ml-2% flex flex-wrap relative z-0 list-none justify-center" }
const _hoisted_20 = {
  key: 3,
  class: "highlights pb-6 relative block"
}
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<h2 class=\"tagline text-base tracking-wider mt-5 mb-2.5 uppercase\"> Animeboxd lets you... </h2><ul class=\"highlights mb-5 flex flex-wrap justify-between\"><li class=\"block mb-2.5 w-full border-none shadow-frame box-border bg-gray-highlights pt-4 px-5 pb-4 rounded-sm text-white relative -top-1 flex\"><span class=\"flex items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-12 w-12\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"#98aabb\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 12a3 3 0 11-6 0 3 3 0 016 0z\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z\"></path></svg></span><p class=\"text-gray-primary ml-3 py-auto text-base text-left flex items-center\"> Keep track of all the anime you&#39;ve ever watched or just start from the day you join. </p></li><li class=\"block mb-2.5 w-full border-none shadow-frame box-border bg-gray-highlights pt-4 px-5 pb-4 rounded-sm text-white relative -top-1 flex\"><span class=\"flex items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-12 w-12\" viewBox=\"0 0 20 20\" fill=\"#98aabb\"><path fill-rule=\"evenodd\" d=\"M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z\" clip-rule=\"evenodd\"></path></svg></span><p class=\"text-gray-primary ml-3 py-auto text-base text-left flex items-center\"> View and edit your MyAnimeList lists. </p></li><li class=\"block mb-2.5 w-full border-none shadow-frame box-border bg-gray-highlights pt-4 px-5 pb-4 rounded-sm text-white relative -top-1 flex\"><span class=\"flex items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-12 w-12\" viewBox=\"0 0 20 20\" fill=\"#98aabb\"><path d=\"M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z\"></path></svg></span><p class=\"text-gray-primary ml-3 py-auto text-base text-left flex items-center\"> Read reviews and find out about the best new anime. </p></li></ul>", 2)
const _hoisted_23 = [
  _hoisted_21
]
const _hoisted_24 = { class: "anime-list relative pb-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h2", { class: "section-heading tracking-wider border-b border-gray-highlights mb-2.5 pb-1.5 uppercase text-base hover:underline" }, " This Seasons Anime... ", -1)
const _hoisted_26 = { class: "anime-list overflow-hidden h-full -ml-2% flex flex-wrap relative z-0 list-none justify-center" }
const _hoisted_27 = { class: "anime-list relative pb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h2", { class: "section-heading tracking-wider border-b border-gray-highlights mb-2.5 pb-1.5 uppercase text-base hover:underline" }, " Top Rated Anime... ", -1)
const _hoisted_29 = { class: "anime-list overflow-hidden h-full -ml-2% flex flex-wrap relative z-0 list-none justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Backdrop = _resolveComponent("Backdrop")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AnimeItem = _resolveComponent("AnimeItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      loginUrl: _ctx.loginUrl,
      verifier: _ctx.verifier
    }, null, 8, ["loginUrl", "verifier"]),
    _createVNode(_component_Backdrop, { animeBackground: _ctx.animeBackground }, null, 8, ["animeBackground"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _createElementVNode("button", {
                  class: "login-link mb-14 mt-14 bg-green-animeboxd text-white text-sm py-1em px-2em cursor-pointer border-none rounded inline-block no-underline tracking-wider uppercase",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveVerifier && _ctx.saveVerifier(...args)))
                }, " Connect with MyAnimeList ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("h1", _hoisted_10, " Welcome back, " + _toDisplayString(_ctx.user.username) + ". ", 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: {
              name: 'Standard List',
              params: { anime: JSON.stringify(_ctx.suggestedAnime), type: 'suggestions' }
            }
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("ul", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestedAnime?.slice(0, 6), (suggestedAnime) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: suggestedAnime.node.id,
                      className: "top-row-anime media-item h-full min-h-full my-0 ml-2% mb-2% xm:ml-2.5 w-23% ms:w-150px bg-black-background mt-0 border-none shadow-none rounded-lg overflow-hidden relative flex flex-wrap content-start whitespace-nowrap"
                    }, [
                      _createVNode(_component_AnimeItem, { anime: suggestedAnime }, null, 8, ["anime"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_14, [
            _createVNode(_component_router_link, {
              to: {
              name: 'Standard List',
              params: { anime: JSON.stringify(_ctx.popularAnime), type: 'most-popular' }
            }
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("ul", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popularAnime?.slice(0, 6), (popularAnime) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: popularAnime.node.id,
                  className: "top-row-anime media-item h-full min-h-full my-0 ml-2% mb-2% xm:ml-2.5 w-23% ms:w-150px bg-black-background mt-0 border-none shadow-none rounded-lg overflow-hidden relative flex flex-wrap content-start whitespace-nowrap"
                }, [
                  _createVNode(_component_AnimeItem, { anime: popularAnime }, null, 8, ["anime"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("section", _hoisted_17, [
            _createVNode(_component_router_link, {
              to: {
              name: 'Standard List',
              params: { anime: JSON.stringify(_ctx.topAiringAnime), type: 'top-airing' }
            }
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("ul", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topAiringAnime?.slice(0, 6), (topAiringAnime) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: topAiringAnime.node.id,
                  className: "top-row-anime media-item h-full min-h-full my-0 ml-2% mb-2% xm:ml-2.5 w-23% ms:w-150px bg-black-background mt-0 border-none shadow-none rounded-lg overflow-hidden relative flex flex-wrap content-start whitespace-nowrap"
                }, [
                  _createVNode(_component_AnimeItem, { anime: topAiringAnime }, null, 8, ["anime"])
                ]))
              }), 128))
            ])
          ]),
          (!_ctx.user)
            ? (_openBlock(), _createElementBlock("section", _hoisted_20, _hoisted_23))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_24, [
            _createVNode(_component_router_link, {
              to: {
              name: 'Standard List',
              params: { anime: JSON.stringify(_ctx.seasonAnime), type: 'this-season' }
            }
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("ul", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasonAnime?.slice(0, 6), (seasonAnime) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: seasonAnime.node.id,
                  className: "top-row-anime media-item h-full min-h-full my-0 ml-2% mb-2% xm:ml-2.5 w-23% ms:w-150px bg-black-background mt-0 border-none shadow-none rounded-lg overflow-hidden relative flex flex-wrap content-start whitespace-nowrap"
                }, [
                  _createVNode(_component_AnimeItem, { anime: seasonAnime }, null, 8, ["anime"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("section", _hoisted_27, [
            _createVNode(_component_router_link, {
              to: {
              name: 'Standard List',
              params: { anime: JSON.stringify(_ctx.topRatedAnime), type: 'top-rated' }
            }
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("ul", _hoisted_29, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topRatedAnime?.slice(0, 6), (topRatedAnime) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: topRatedAnime.node.id,
                  className: "top-row-anime media-item h-full min-h-full my-0 ml-2% mb-2% xm:ml-2.5 w-23% ms:w-150px bg-black-background mt-0 border-none shadow-none rounded-lg overflow-hidden relative flex flex-wrap content-start whitespace-nowrap"
                }, [
                  _createVNode(_component_AnimeItem, { anime: topRatedAnime }, null, 8, ["anime"])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}